export default __webpack_public_path__ + "static/media/hlp_adaclub_arma_tempo_agrega.a2ca577d.jpg";